import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';
import { AccountRecordExtended } from '@tassat/fred-extended-definitions';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { muiStyles } from './styles';
import { ClientTransactionHistory } from './transactionHistory';

export interface ClientTransactionHistoryProps extends WithStyles<typeof muiStyles>,
    RouteComponentProps<any, any, { linkedRequestId: string; direction: string }> {
    firm: FirmRecord;
    account?: AccountRecordExtended;
    overlayOpen?: boolean;
}

export default withRouter(withStyles(muiStyles)(ClientTransactionHistory));